module.exports = __webpack_public_path__ + "img/03-light.7a9b0cd4.png";